import React from 'react';

import { IconWrapper } from '../styled-components';
import { ReactComponent as attachment } from './attach.svg';
import styled from "styled-components";
const AttachmentIcon = styled(attachment)`
  
`

type AttachmentLogoProps = {
  scale?: number;
  altText: string;
};

const Attachment: React.FC<AttachmentLogoProps> = ({ scale = 1, altText }) => {
  
  return (
    <IconWrapper width={2 * scale} height={2 * scale} aria-label={altText} style={{"marginTop": "0px", "width": "1rem", marginLeft: "1px"}}>
      <AttachmentIcon/>
    </IconWrapper>
  );
};

export default Attachment;